module.exports = __webpack_public_path__ + "img/grid4-bg.a884637.png";